import { userConstants } from "../constants/login.constants";

 function annualStatementMonthStatus(state = {}, action) {
    switch (action.type) {
        case userConstants.ANNUALSTATEMENTMONTHSTATUS_REQUEST:
            return {
                loading: true
            };
        case userConstants.ANNUALSTATEMENTMONTHSTATUS_SUCCESS:
            return {
                items: action.annualStatementMonthStatus
            };
        case userConstants.ANNUALSTATEMENTMONTHSTATUS_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default annualStatementMonthStatus;